module.exports = __webpack_public_path__ + "img/img2.94f4e104.png";